import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Carta di credito',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Paga tramite banca',
    [PaymentMethod.SepaDebit]: 'EC-Card / IBAN',
    [PaymentMethod.Cash]: 'Contanti',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Altro metodo di pagamento',
  },
};
